import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker, message} from "antd";
import Select from "react-select";
import { Link } from 'react-router-dom';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Country, State } from "country-state-city";
import { addhospital } from "../../services/admin/hospital/hospital";
import { useMessageApi } from "../../services/message api/MessageProvider";

const AddHospital = () => {
    const [isClicked, setIsClicked] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    const [country, setCountry] = useState();
    const [statevalue, setStateValue] = useState();
  
    useEffect(() => {
      const states = State.getStatesOfCountry("IN"); 
      const formattedStates = states?.map((state) => ({
        label: state.name,
        value: state.name,
      }));
      const options = Country.getAllCountries()?.map((country) => ({
        label: country.name,
        value: country.name,
      }));
      setCountry(options);
      setStateValue(formattedStates);
    }, []); 
  
    const [formData, setFormData] = useState({
      name: "",
      email: "",
      password: "",
      mobile: "",
      address: "",
      city: "",
      state: "",
      country: "",
      pincode: "",
      status: "active",
      start_date: "",
      end_date: "",
      no_of_days: "",
      how_many_create_receptionist: "",
      how_many_create_pharmacy: "",
      // 👇 NEW FIELDS
      bill_no_sequence_prefix: "",
      bill_no_sequence_start: "",
      bill_receipt_no_start: "",
    });
  
    const [errors, setErrors] = useState({});
  
    const validateForm = () => {
      let newErrors = {};
  
      if (!formData.name.trim()) {
        newErrors.name = "Hospital Name is required";
      }
      if (!formData.password.trim()) {
        newErrors.password = "Password is required";
      }
      if (!formData.email.trim()) {
        newErrors.email = "email is required";
      }
      if (!formData.mobile.trim()) {
        newErrors.mobile = "mobile is required";
      }
      if (!formData?.confirmPassword?.trim()) {
        newErrors.confirmPassword = "Confirm Password is required";
      } else if (formData.confirmPassword !== formData.password) {
        newErrors.confirmPassword = "Passwords does not match";
      }
      if (!formData.start_date) {
        newErrors.start_date = "Start Date is required";
      }
      if (!formData.end_date) {
        newErrors.end_date = "End Date is required";
      } else if (new Date(formData.start_date) > new Date(formData.end_date)) {
        newErrors.end_date = "End Date must be after Start Date";
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };

    const calculateDays = (start, end) => {
        if (!start || !end) return "";
        
        const start_date = new Date(start);
        const end_date = new Date(end);
        const timeDiff = end_date - start_date;
        const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1; // +1 to include both start and end days
        
        return daysDiff > 0 ? daysDiff.toString() : "";
      };
  
    const handleChange = (eventOrValue, fieldName) => {
      setFormData((prevData) => {
        let newData = { ...prevData };
    
        // Handle normal input fields
        if (eventOrValue && eventOrValue.target) {
          const { name, value, type, checked } = eventOrValue.target;
          if (name) {
            newData[name] = type === 'checkbox' ? checked : value;
          }
        }
        else if (fieldName && (fieldName === "start_date" || fieldName === "end_date")) {
            const dateValue = eventOrValue ? eventOrValue.toISOString().split("T")[0] : "";
            newData[fieldName] = dateValue;
            
            // Calculate days when both dates are present
            if ((fieldName === "start_date" && newData.end_date) || 
                (fieldName === "end_date" && newData.start_date)) {
              const start = new Date(newData.start_date);
              const end = new Date(newData.end_date);
              const timeDiff = end - start;
              const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1; // +1 to include both dates
              newData.no_of_days = daysDiff > 0 ? daysDiff.toString() : "";
            } else {
              newData.no_of_days = "";
            }
          }

        // Handle DatePicker or other direct value components
        else if (fieldName) {
          newData[fieldName] = eventOrValue || "";
        }
        // Handle React-Select (single & multi-select cases)
        else if (eventOrValue && typeof eventOrValue === "object" && "value" in eventOrValue) {
          newData[fieldName] = eventOrValue.value;
        }
       
    
        return newData;
      });
    };
    message.config({
      top: 100, // distance from top
      duration: 3,
      placement: 'topRight', // <-- key part for right side
    });
const messageApi = useMessageApi();

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      if (validateForm()) {
        console.log("Form submitted successfully!", formData);
        try {
          const result = await addhospital(formData); 
          if (result.success) {
            messageApi.open({
              type: 'success',
              content: 'Hospital added successfully!',
            });
          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              messages.forEach((msg) => {
                messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error.message);
          // Show error to user
        }
      } else {
        console.log("Form validation failed");
      }
    };
  
    return (
      <div>
        <Header />
        <Sidebar activeClassName="hospital" />
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/hospitallist">Hospitals</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Hospital</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Hospital Details</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-12">
                          <div className="form-group local-forms">
                            <label>
                              Hospital Name{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              placeholder="Enter Hospital Name"
                              onChange={(e) => {
                                const formatted = e.target.value
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase(),
                                  );
                                e.target.value = formatted;
                                handleChange(e); // keep your existing handler
                              }}
                            />
                            {errors.name && (
                              <p style={{ color: "red" }}>{errors.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="email"
                              type="email"
                              placeholder="admin@medalluvpharma.com"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Mobile <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="mobile"
                              type="text"
                              placeholder="Enter Mobile"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="password"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.password && (
                              <p style={{ color: "red" }}>{errors.password}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Confirm Password{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="confirmPassword"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.confirmPassword && (
                              <p style={{ color: "red" }}>
                                {errors.confirmPassword}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group local-forms">
                            <label>
                              Address
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="address"
                              type="text"
                              placeholder="Enter Address"
                              onChange={handleChange}
                            />
                            {errors.address && (
                              <p style={{ color: "red" }}>{errors.address}</p>
                            )}
                          </div>
                        </div>
                        {/* City Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>City</label>
                            <input
                              className="form-control"
                              name="city"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.city && (
                              <p style={{ color: "red" }}>{errors.city}</p>
                            )}
                          </div>
                        </div>

                        {/* State Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>State</label>
                            <Select
                              menuPosition={"fixed"}
                              name="state"
                              value={
                                statevalue?.find(
                                  (option) => option.value === formData.state,
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                handleChange(selectedOption?.label, "state")
                              }
                              options={statevalue}
                              placeholder="Select State"
                              menuPortalTarget={document.body}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                            {errors.state && (
                              <p style={{ color: "red" }}>{errors.state}</p>
                            )}
                          </div>
                        </div>

                        {/* Country Select */}
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>Country</label>
                            <Select
                              menuPosition={"fixed"}
                              name="country"
                              value={
                                country?.find(
                                  (option) => option.value === formData.country,
                                ) || null
                              }
                              onChange={(selectedOption) =>
                                handleChange(selectedOption?.label, "country")
                              }
                              options={country}
                              placeholder="Select Country"
                              menuPortalTarget={document.body}
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                            {errors.country && (
                              <p style={{ color: "red" }}>{errors.country}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Pin Code
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="pincode"
                              type="text"
                              placeholder="Enter Pin Code"
                              onChange={handleChange}
                            />
                            {errors.pincode && (
                              <p style={{ color: "red" }}>{errors.pincode}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">Status</label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  onChange={handleChange}
                                  value="active"
                                  className="form-check-input"
                                />
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="female"
                                  name="gender"
                                  defaultChecked
                                  className="form-check-input"
                                />
                                Deactive
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              Start Date <span className="login-danger">*</span>
                            </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={
                                formData.start_date
                                  ? new Date(formData.start_date)
                                  : null
                              }
                              onChange={(date) =>
                                handleChange(date, "start_date")
                              }
                              placeholderText="Enter Start Date"
                            />
                            {errors.start_date && (
                              <p style={{ color: "red" }}>
                                {errors.start_date}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms cal-icon">
                            <label>
                              End Date <span className="login-danger">*</span>
                            </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={
                                formData.end_date
                                  ? new Date(formData.end_date)
                                  : null
                              }
                              onChange={(date) =>
                                handleChange(date, "end_date")
                              }
                              placeholderText="Enter End Date"
                            />
                            {errors.end_date && (
                              <p style={{ color: "red" }}>{errors.end_date}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>No of Days</label>
                            <input
                              className="form-control"
                              name="no_of_days"
                              type="text"
                              placeholder="No of Days (auto-calculated)"
                              value={formData.no_of_days || ""}
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>
                              Bill No Prefix{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="bill_no_sequence_prefix"
                              type="text"
                              placeholder="e.g. SH1"
                              value={formData.bill_no_sequence_prefix}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>
                              Bill No Start{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="bill_no_sequence_start"
                              type="number"
                              placeholder="e.g. 1001"
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-4">
                          <div className="form-group local-forms">
                            <label>
                              Bill Receipt Start{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="bill_receipt_no_start"
                              type="number"
                              placeholder="e.g. 101"
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>How Many Create Receptionist</label>
                            <input
                              className="form-control"
                              name="how_many_create_receptionist"
                              type="text"
                              placeholder="How Many Create Receptionist"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-group local-forms">
                            <label>How Many Create Pharmacy</label>
                            <input
                              className="form-control"
                              name="how_many_create_pharmacy"
                              type="text"
                              placeholder="How Many Create Pharmacy"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default AddHospital
